/**
 * DedupBadge (PHASE1 §7.4). Colour-coded badge for an import row's dedup
 * verdict, using the German labels from `lib/labels`.
 */
import { DEDUP } from '../../lib/labels.ts';
import type { DedupWire } from '../../lib/types.ts';

// Badge palette per DESIGN.md §3.11: solid pastel pills.
const STYLE: Record<DedupWire, string> = {
  new: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300',
  duplicate: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300',
  possible_duplicate: 'bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300',
  ignored: 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400',
};

export function DedupBadge({ outcome }: { outcome: DedupWire }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${STYLE[outcome]}`}
    >
      {DEDUP[outcome]}
    </span>
  );
}
